import gopaasFavorisViews from '@/constants/gopaasFavorisViews.json';
import gopaasMatchReactionViews from '@/constants/gopaasMatchReactionViews.json';

const GOPAAS_ORIGIN = 'https://nids-qualif.gopaas.net/sandbox/tifosi/';
const DEFAULT_PROXY_BASE = '/gopaas-api/';
const DEFAULT_PROD_API_BASE = '/app/gopaas-api/';

const resolvedApiBaseUrl = (() => {
  const fromEnv = (import.meta.env.VITE_API_BASE_URL || '').trim();
  if (fromEnv) return fromEnv;
  return import.meta.env.PROD ? DEFAULT_PROD_API_BASE : DEFAULT_PROXY_BASE;
})();

/** Feuille de match sur le portail FFF (clé numérique ou identifiant epreuves). */
export function fffMatchSheetUrl(matchKey: string): string {
  const k = String(matchKey || '').trim();
  return `https://epreuves.fff.fr/competition/match/${encodeURIComponent(k)}/match`;
}

/** Classement epreuves.fff.fr pour le même match (même clé que la feuille de match). */
export function fffMatchClassementUrl(matchKey: string): string {
  const k = String(matchKey || '').trim();
  return `https://epreuves.fff.fr/competition/match/${encodeURIComponent(k)}/classement`;
}

/** Clé epreuves.fff.fr : champ API dédié ou `cle` GoPaaS sur match_football (souvent l’id FFF du match). */
export function getMatchEpreuvesKey(match: { match_key?: string; cle?: string }): string | undefined {
  const k = String(match.match_key ?? match.cle ?? '').trim();
  return k || undefined;
}

export const CONFIG = {
  APP_VERSION: 'v0.9.2',
  API_BASE_URL: resolvedApiBaseUrl,
  ASSET_BASE_URL: import.meta.env.VITE_ASSET_BASE_URL || GOPAAS_ORIGIN,
  BEARER_TOKEN: 'DDY2RJ00SLMCJIIX2RWE4F',
  TIFOSI_LIST_ID: '703',
  /** Listes GoPaaS pour favoris relationnels — générées par `scripts/gopaas-setup-favoris-tables.mjs`. */
  TIFOSI_CLUB_LIST_ID:
    (import.meta.env.VITE_TIFOSI_CLUB_LIST_ID || gopaasFavorisViews.tifosiClubListId || '').trim(),
  TIFOSI_MATCH_LIST_ID:
    (import.meta.env.VITE_TIFOSI_MATCH_LIST_ID || gopaasFavorisViews.tifosiMatchListId || '').trim(),
  /** Liste GoPaaS `match_reaction` — générée par `scripts/gopaas-setup-match-reactions.mjs`. */
  MATCH_REACTION_LIST_ID:
    (import.meta.env.VITE_MATCH_REACTION_LIST_ID || gopaasMatchReactionViews.matchReactionListId || '').trim(),
  ENDPOINTS: {
    MATCHES: 'api/list/694',
    CLUBS: 'api/list/681',
    TIFOSI: 'api/list/703',
    OBSERVATIONS: 'api/list/686',
    FAN_ZONE: 'api/list/706',
    /** Phrases types d’observation — champs `commentaire`, `poste`, `type`. */
    COMMENT_TEMPLATES: 'api/list/718',
    MATCH_DETAIL: 'api/item/match_football',
    TIFOSI_ITEMS: 'api/items/tifosi',
    TIFOSI_CLUB_ITEMS: 'api/items/tifosi_club',
    TIFOSI_MATCH_ITEMS: 'api/items/tifosi_match',
    FAN_ZONE_ITEMS: 'api/items/fan_zone',
    MATCH_REACTION_ITEMS: 'api/items/match_reaction',
    /** Fiches événements d’usage (ex. match_opened) — table GoPaaS `tifosi_event`. */
    TIFOSI_EVENT_ITEMS: 'api/items/tifosi_event',
  },
  CACHE_TTL: 5 * 60 * 1000,
  REQUEST_TIMEOUT: 15000,
};

export default CONFIG;
